<template>
	<div class="progress-bar">
		<span
			class="progress-bar__current"
			:ref="'sizeOfLabel'"
			:style="{
				left:
					width < 50
						? `calc(${width}% + 5px)`
						: `calc(${width}% - ${offset}px)`,
			}"
			>{{ label ? label : `${width}%` }} bonus</span
		>
		<div class="progress-bar__loader" :style="{ width: width + '%' }"></div>
	</div>
</template>

<script>
export default {
	props: {
		width: {
			type: Number,
			required: true,
			default: 0,
		},
		label: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			offset: 30,
		};
	},
	watch: {
		width(n, o) {
			if (n) this.getLabelOffset();
		},
	},
	mounted() {
		this.getLabelOffset();
	},
	methods: {
		getLabelOffset() {
			this.offset = this.$refs.sizeOfLabel.offsetWidth + 5;
		},
	},
};
</script>

<style lang="scss">
.progress-bar {
	background: var(--light-gray);
	position: relative;
	&__loader {
		height: 16px;
		width: 0%;
		transition: 500ms;
		background: var(--green);
		border-radius: 10px;
	}
	&__current {
		position: absolute;
		left: -5px;
		top: 50%;
		transform: translateY(-50%);
		font-size: var(--font-smallest);
		white-space: nowrap;
	}
	&__max {
		position: absolute;
		right: 5px;
		top: 50%;
		transform: translateY(-50%);
		font-size: var(--font-smallest);
	}
}
</style>
